<template>
  <div class="message">
    <div class="title">
      <p>消息中心</p>
    </div>
    <div class="main">
      <el-tabs v-model="activeName"
               @tab-click="handleClick">
        <el-tab-pane label="审核消息"
                     name="1">
          <div slot="label">
            <el-badge :value="unread_count"
                      :hidden="unread_count == 0"
                      class="item"> 审核消息 </el-badge>
          </div>
        </el-tab-pane>
        <el-tab-pane label="通知公告"
                     name="2"> </el-tab-pane>
      </el-tabs>
      <div class="table">
        <el-table ref="multipleTable"
                  :data="tableData"
                  tooltip-effect="dark"
                  style="width: 100%"
                  @selection-change="handleSelectionChange"
                  v-loading="load">
          <el-table-column type="selection"
                           width="55"
                           v-if="activeName == 1"> </el-table-column>
          <el-table-column v-if="activeName == 1">
            <template slot-scope="scope">
              <div @click="showDetail(scope.row)"
                   class="item">
                <el-badge is-dot
                          class="item"
                          :hidden="scope.row.is_read == 1">
                  <p v-html="subTiFmt(scope.row.notice_title)"></p>
                </el-badge>
                <span v-if="scope.row.sub_type == 3">
                  <span>店铺类型：{{ shop_type[scope.row.shop_type - 1] }}</span>
                  <span>店铺价格：{{ scope.row.amount }} 元</span>
                </span>
                 <span v-if="scope.row.sub_type == 1" >
                  <span>商品名称:{{ scope.row.goods_title }}</span>
                  <span>商品ID:{{ scope.row.goods_id }}</span>
                  </span>
                 <span v-if="scope.row.sub_type == 2" >
                    <span>活动标题：:{{ scope.row.title }}</span>
                  <span v-for="(item,index) in scope.row.goods_names" :key="index">商品名称:{{ item }}</span>
                  </span>

              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="activeName == 2">
            <template slot-scope="scope">
              <div @click="showDetail(scope.row, 1)"
                   class="item2">
                <p>{{ scope.row.title }}</p>
                <p>公告内容：{{ scope.row.content }}</p>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="card"
           v-if="tableData.length != 0 && activeName == 1">
        <div class="left">
          <el-checkbox v-model="checkedAll"
                       @change="toggleSelection">全选</el-checkbox>
          <p>
            <i class="el-icon-warning"></i>
            已选择
            <span> {{ multipleSelection ? multipleSelection.length : 0 }}</span>项
          </p>
        </div>
        <div class="right">
          <el-button type="info"
                     size="mini"
                     :loading="readBtn"
                     @click="markReadFn">标记已读</el-button>
          <el-button type="danger"
                     size="mini"
                     :loading="delBtn"
                     @click="noticeDeleteFn">删除</el-button>
        </div>
      </div>
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="page"
                     :page-sizes="[10, 20, 30, 40]"
                     :page-size="size"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total"
                     background>
      </el-pagination>
    </div>
   <el-dialog title="详情"
               :visible.sync="dialogVisible"
               width="576px">
      <div class="detail">
        <div class="icon"
             v-if="urgent != 1&&row" >
          <i
                        :class="row.audit_status == 2  ? 'el-icon-success' : 'el-icon-error'"
                        :style="{
                            color: row.audit_status == 2 ? '#14C855' : '#E72F0D',
                        }"
                    ></i>
          <p>
            {{ row.notice_title }}
          </p>
        </div>
        <el-form label-width="120px"
                 label-position="left">
          <div v-if="urgent == 1">
            <el-form-item label="标题">{{ row.title }} </el-form-item>
            <el-form-item label="内容">{{ row.content }}</el-form-item>
            <el-form-item label="通知附件"
                          v-if="row.attachment">
              <p class="file"><a :href="row.attachment"
                   target="_blank">点击下载</a></p>
            </el-form-item>
          </div>
          <div v-else>
            <div v-if="row.sub_type == 1">
              <el-form-item label="商品ID">{{ row.goods_id }}</el-form-item>
              <el-form-item label="商品名称">{{ row.goods_title }}</el-form-item>
              <el-form-item label="提交时间">{{ row.apply_date }}</el-form-item>
              <el-form-item label="审核时间">{{ row.audit_date }}</el-form-item>
              <el-form-item label="审核状态">{{ row.audit_status == 1 ? "待审核" : row.audit_status == 2 ? "审核通过" : "审核拒绝" }}</el-form-item>
              <el-form-item v-if="row.audit_status == 3"
                            label="审核原因">{{ row.audit_refuse_reason }}</el-form-item>
            </div>
            <div v-else-if="row.sub_type == 2">
              <el-form-item label="活动标题">{{ row.title ? row.title : "-" }}</el-form-item>
              <el-form-item label="商品名">
                <span v-for="(v, i) in row.goods_names"
                      :key="i">
                  {{ v + "," }}
                </span>
              </el-form-item>
              <el-form-item label="活动时间">
                <div v-if="!!row.start_time && !!row.end_time">
                  {{ row.start_time + "~" + row.end_time }}
                </div>
                <div v-else>-</div>
              </el-form-item>
              <el-form-item label="审核时间">{{ row.send_time }}</el-form-item>
              <el-form-item label="审核状态">{{ row.audit_status == 1 ? "待审核" : row.audit_status == 2 ? "审核通过" : "审核失败" }}</el-form-item>
              <el-form-item label="审核失败原因"
                            v-if="row.audit_status == 3">{{ row.audit_rejection_reason }}</el-form-item>
              <!-- <el-form-item label="审核失败图片"
                            v-if="row.audit_status == 3">
                <el-image :src="row.image"
                          v-if="row.image"></el-image>
                <span v-else>-</span> 
              </el-form-item>-->
            </div>
            <div v-if="row.sub_type == 3">
              <el-form-item label="店铺类型">{{ shop_type[row.shop_type - 1] }}</el-form-item>
              <el-form-item label="店铺使用费">{{ row.amount }} 元</el-form-item>
              <el-form-item label="提交时间">{{ row.apply_date }}</el-form-item>
              <el-form-item label="审核时间">{{ row.audit_date }}</el-form-item>
              <el-form-item label="审核状态">{{ row.audit_status == 1 ? "待审核" : row.audit_status == 2 ? "审核通过" : "审核拒绝" }}</el-form-item>
              <el-form-item v-if="row.audit_status == 3"
                            label="审核原因">{{ row.audit_refuse_reason }}</el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false"
                   size="medium">取 消</el-button>
        <el-button type="primary"
                   size="medium"
                   @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog> 
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  data () {
    return {
      readBtn: false,
      delBtn: false,
      dialogVisible: false,
      activeName: "1",
      tableData: [],
      size: 10,
      page: 1,
      total: 0,
      load: false,
      row: {},
      multipleSelection: [],
      checkedAll: false,
      unread_count: 0,
      tabLoading: true,
      shop_type: ["品牌官方店", "品牌旗舰店", "品牌专卖店", "品牌专营店"],
      urgent: 0,
    };
  },

  computed: {
    ...mapGetters(["getToken"]),
  },
  created () {
    this.getList(1);
  },
  methods: {
    ...mapActions({
      getNoticeList: "commodity/getNoticeList",
      markRead: "commodity/markRead",
      agencyMessage: "detect/agencyMessage",
      noticeDelete: "commodity/noticeDelete",
    }),
    ...mapMutations({
      setUnreadCount: "setUnreadCount",
    }),
    subTiFmt (val) {
      let start = val.indexOf("【");
      let end = val.indexOf("】");
      let str = val.slice(start, end + 1);
      return val.replace(str, `<span class="subTitle">${str}</span>`);
    },
    markReadFn (id) {
      let opt = {
        token: this.getToken,
      };
      if (typeof id != "object") {
        opt.id = id;
        this.markRead(opt).then((res) => {
          // console.log(res);
          if (res.code == 1) {
            // console.log(res.data.msg);
            this.tabLoading = false;
            this.getList();
          } else {
            // console.log(res.msg);
          }
        });
      } else {
        this.readBtn = true;
        this.$confirm("是否全部标记为已读？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            this.markRead(opt).then((res) => {
              this.readBtn = false;
              // console.log(res);
              if (res.code == 1) {
                // console.log(res.data.msg);
                this.getList();
              } else {
                // console.log(res.msg);
              }
            });
          })
          .catch(() => {
            this.readBtn = false;
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    showDetail (row, tag) {
      this.urgent = tag;
      this.row = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
      if (this.row.is_read == 0) {
        row.is_read = 1;
        this.markReadFn(this.row.notice_id);
      }
    },
    noticeDeleteFn () {
      if (this.multipleSelection && this.multipleSelection.length == 0) {
        return this.$message.warning("请选择需要删除的消息！");
      }
      this.delBtn = true;
      let id_arr = this.multipleSelection.map((item) => {
        return item.notice_id;
      });
      let opt = {
        token: this.getToken,
        notice_ids: id_arr,
      };
      this.$confirm("此操作将永久删除选择消息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await this.noticeDelete(opt);
          this.delBtn = false;
          // console.log(res);
          if (res.code == 1) {
            this.$message.success("删除成功！");
            this.getList();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {
          this.delBtn = false;
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange (val) {
      this.size = val;
      if (this.activeName == 1) {
        this.getList(1);
      } else {
        this.getAgencyMessage(1);
      }
    },
    handleCurrentChange (val) {
      this.page = val;
      if (this.activeName == 1) {
        this.getList();
      } else {
        this.getAgencyMessage();
      }
    },
    getList (val) {
      if (this.tabLoading == true) {
        this.load = true;
      }
      let opt = {
        token: this.getToken,
        type: 1, //消息类型，1-审核消息
        page_size: this.size, //页大小
        page: val == 1 ? 1 : this.page, //页数
      };
      this.getNoticeList(opt).then((res) => {
        this.load = false;
        this.tabLoading = true;
        if (res.code == 1) {
          console.log(res.data.data,'res.data.data----')
          this.tableData = res.data.data;
          this.total = res.data.total ? res.data.total : 0;
          this.unread_count = res.data.unread_count ? res.data.unread_count : 0;
          this.setUnreadCount(res.data.unread_count ? res.data.unread_count : 0);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getAgencyMessage (val) {
      if (this.tabLoading == true) {
        this.load = true;
      }
      let opt = {
        token: this.getToken,
        limit: this.size, //页大小
        page: val == 1 ? 1 : this.page, //页数
        is_read: 3,
      };
      this.agencyMessage(opt).then(({ data }) => {
        this.tabLoading = false;
        this.load = false;
        console.log(data);
        if (data.code == 1) {
          this.tableData = data.data.notice;
          this.total = data.data.count ? data.data.count : 0;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleClick () {
      this.tableData = [];
      if (this.activeName == 1) {
        this.getList(1);
      } else {
        this.getAgencyMessage(1);
      }
    },
    toggleSelection () {
      this.$nextTick(() => {
        this.$refs.multipleTable.toggleAllSelection();
      });
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length == this.tableData.length) {
        this.checkedAll = true;
      } else {
        this.checkedAll = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.message {

  .title {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    width: 100%;
    background: #fff;
    padding: 15px 32px;
    display: flex;
    align-items: center;
    p {
      font-size: 20px;
      color: #000000;
      margin-left: 0;
    }
  }

  & > .main {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    background: #fff;
    margin: 24px;
    padding: 30px;
    padding-bottom: 70px;
    min-height: 700px;
    min-width: 1200px;
  }
  .pageSize {
    margin-top: 40px;
    text-align: right;
  }
  .table {
    min-height: 550px;
    ::v-deep .el-table thead {
      display: none !important;
    }
    .item {
      cursor: pointer;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      p {
        font-size: 16px;
      }
      span {
        margin-top: 10px;
        margin-right: 40px;
      }
    }
  }
  // ::v-deep .el-tabs__item {
  //     padding: 0 30px !important;
  // }
  ::v-deep #tab-first {
    padding-left: 0 !important;
  }
  ::v-deep .el-badge__content.is-fixed {
    top: 50% !important;
    right: -5px !important;
  }
  .el-pagination {
    text-align: right;
    margin-top: 20px;
  }
  .detail {
    .icon {
      font-size: 48px;
      text-align: center;
      p {
        font-size: 18px;
        margin: 20px 0;
      }
    }

    .el-form {
      background: #eee;
      padding: 14px;
    }
  }
  .card {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    background: #e6f7ff;
    border: 1px solid #bae7ff;
    .left {
      display: flex;
      .el-checkbox {
        margin-right: 20px;
      }
      i {
        color: #1890ff;
      }
      span {
        color: #1890ff;
        margin: 0 4px;
      }
    }
    .right {
      .el-button {
        min-width: 80px;
      }
    }
  }
}
::v-deep .subTitle {
  color: #7616d5;
}
.item2 {
  display: flex;
  flex-direction: column;
  p {
    line-height: 32px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  cursor: pointer;
}
</style>